import React from 'react';
import { prop, pick } from 'ramda';
import { useAppSelector, useUserSelector, useDeviceSelector } from 'js/store/hooks';

import * as style from './AdditionalUserInfo.scss';

export const AdditionalUserInfo: React.FC = () => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const isItalianHeaderEnabled = useAppSelector(prop('isItalianHeaderEnabled'));
    const {
        isLoggedIn, userDetails: { firstName, lastName, personalId }
    } = useUserSelector(pick(['isLoggedIn', 'userDetails']));

    return isItalianHeaderEnabled && isLoggedIn
        ? (
            <div className={style.userAdditionalInfo}>
                <span>{`${firstName} ${lastName}`}</span>
                {!isDesktop && <span className={style.separator}>{'|'}</span>}
                <span>{personalId}</span>
            </div>
        )
        : null;
};
